export default __webpack_public_path__ + "static/media/gloves1.f90e48bc.jpg";